import {
  RevisionDeletedFragment,
  RevisionUnavailableFragment,
  RevisionInfoFragment,
  CommentInfoFragment,
} from 'gqlTypes'

export type Activity =
  | CommentInfoFragment
  | RevisionInfoFragment
  | RevisionDeletedFragment
  | RevisionUnavailableFragment

// User defined type guards to easily narrow down Activity

export const isComment = (
  activity?: Activity
): activity is CommentInfoFragment =>
  activity?.__typename === 'Comment' ||
  !!((activity as unknown) as CommentInfoFragment)?.body

export const isUnreadComment = (
  activity?: Activity
): activity is CommentInfoFragment => isComment(activity) && !activity.isRead

export const isCommentWithReplies = (
  activity?: Activity
): activity is CommentInfoFragment =>
  isComment(activity) && !!activity?.replies?.length

export const isReply = (activity?: Activity): activity is CommentInfoFragment =>
  isComment(activity) && !!activity.parent?.identifier

export const isUnreadReply = (
  activity?: Activity
): activity is CommentInfoFragment => isReply(activity) && !activity.isRead

export const isRevision = (
  activity?: Activity
): activity is RevisionInfoFragment => activity?.__typename === 'Revision'

export const isRevisionDeleted = (
  activity?: Activity
): activity is RevisionDeletedFragment =>
  activity?.__typename === 'RevisionDeleted'

export const isRevisionUnavailable = (
  activity?: Activity
): activity is RevisionUnavailableFragment =>
  activity?.__typename === 'RevisionUnavailable'

export const isOwnComment = (
  activity?: Activity
): activity is CommentInfoFragment =>
  isComment(activity) && activity?.userIsCreator
